query FileCabinetPools(
  $orderBy: [FileCabinetPoolsOrderBy!]
  $filter: FileCabinetPoolFilter
) {
  fileCabinetPools(orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      name
      description
      isDocumentTypeSelector
      extractionTypeId
      defaultDocumentTypeId
      fileCabinetPoolTotals {
        availableDocuments
        selectedDocuments
      }
    }
  }
}
